import { Address } from '@spartacus/core';
import { StatusRequest } from '../../../../../core/models/request-status.model';
import { Option } from '../../../../../core/models/option.model';
import { DeliveryMode } from '@spartacus/cart/base/root/models';

export enum CUSTOM_DELIVERY_METHOD {
  MARATHON_BEST_WAY = 'MARATHON_BEST_WAY',
  CUSTOMER_SPECIFIED_CARRIER = 'CUSTOMER_SPECIFIED_CARRIER',
  CUSTOMER_PICKUP = 'CUSTOMER_PICKUP',
}

export interface AddressRequest extends StatusRequest {
  address?: Address;
}

export interface ShippingPreferencesRequest extends StatusRequest {
  preferences?: Option[];
}

export interface CarriersRequest extends StatusRequest {
  carriers?: Option[];
}

export interface SubDeliveryMethodsRequest extends StatusRequest {
  methods?: DeliveryMode[];
}
